module.exports = __webpack_public_path__ + "static/media/idea-lifecycle.0dffba79.png";